var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArcticonsYahooMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 35.5V12.5C43.5 11.9696 43.2893 11.4609 42.9142 11.0858C42.5391 10.7107 42.0304 10.5 41.5 10.5H6.5C5.96957 10.5 5.46086 10.7107 5.08579 11.0858C4.71071 11.4609 4.5 11.9696 4.5 12.5V35.5C4.5 36.0304 4.71071 36.5391 5.08579 36.9142C5.46086 37.2893 5.96957 37.5 6.5 37.5H41.5C42.0304 37.5 42.5391 37.2893 42.9142 36.9142C43.2893 36.5391 43.5 36.0304 43.5 35.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 14.981L24 24L4.5 14.981",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcticonsYahooMail);
export default __webpack_public_path__ + "static/media/arcticons_yahoo-mail.897185f213f1fd7ac8dcc7c08d3d0815.svg";
export { ForwardRef as ReactComponent };